import React from 'react'

const List = () => {
    return (
        <div className='container'>
            <h1>List</h1>
            <p>The most basic data structure in Python is the sequence. Each element of a sequence is assigned a number - its position or index. The first index is zero, the second index is one, and so forth.
<br /> <br />
Python has six built-in types of sequences, but the most common ones are lists and tuples, which we would see in this tutorial.
<br /><br />
There are certain things you can do with all sequence types. These operations include indexing, slicing, adding, multiplying, and checking for membership. In addition, Python has built-in functions for finding the length of a sequence and for finding its largest and smallest elements.</p><br /><br />
        
        <h2>Python Lists</h2>
        The list is a most versatile datatype available in Python which can be written as a list of comma-separated values (items) between square brackets. Important thing about a list is that items in a list need not be of the same type.
<br /> <br />
Creating a list is as simple as putting different comma-separated values between square brackets. <br /> For example − <br />
   <div className='containers'>
  <code className='keywords'> list1</code> = ['physics', 'chemistry', 1997, 2000]; <br />
  <code className='keywords'>list2 </code>= [1, 2, 3, 4, 5 ]; <br />
  <code className='keywords'>list3 </code>= ["a", "b", "c", "d"] <br />
   </div>
   <p>Similar to string indices, list indices start at 0, and lists can be sliced, concatenated and so on.</p>
   <h3>Accessing Values in Lists</h3>
   <p>To access values in lists, use the square brackets for slicing along with the index or indices to obtain value available at that index. For example −</p> <br />
<div className='containers'>
<code className='keywords'>list1</code> = ['physics', 'chemistry', 1997, 2000];<br />
<code className='keywords'>list2</code> = [1, 2, 3, 4, 5, 6, 7 ];<br />
<code className='library'>print</code> "list1[0]: ", list1[0]<br />
<code className='library'>print</code> "list2[1:5]: ", list2[1:5]<br />
</div>
<p>When the above code is executed, it produces the following result −</p>
<div className='containers'>
<code className='keywords'>list1[0]</code>:  physics <br />
<code className='keywords'>list2[1:5]</code>:  [2, 3, 4, 5] <br/>
</div>

<h3>Updating Lists</h3>
You can update single or multiple elements of lists by giving the slice on the left-hand side of the assignment operator, and you can add to elements in a list with the append() method. <br /> For example <br />
<div className='containers'>
<code className='keywords'> list</code> = ['physics', 'chemistry', 1997, 2000]; <br />
<code className='library'>print</code> "<code className='plain'> Value available at index 2</code> : " <br />
<code className='library'>print</code> list[2] <br />
<code className='keywords'>list[2]</code> = 2001; <br />
<code className='library'>print</code> "New value available at index 2 : " <br />
<code className='library'>print</code> list[2]</div>
<b>Note </b> − append() method is discussed in subsequent section. <br /> <br />

When the above code is executed, it produces the following result − <br />
<div className='containers'>
Value available at index 2 : <br />
1997 <br />
New value available at index 2 : <br />
2001 <br />
</div><h3>Delete List Elements</h3>
To remove a list element, you can use either the del statement if you know exactly which element(s) you are deleting or the remove() method if you do not know. For example − <br />
<div className='containers'>
<code className='keywords'> list1</code> = ['physics', 'chemistry', 1997, 2000]; <br />
<code className='library'>print</code> list1 <br />
<code className='keywords'>del</code> list1[2]; <br />
<code className='library'>print</code> "<code className='plain'> After deleting value at index 2</code> : " <br />
<code className='library'>print</code> list1 <br />
</div>
When the above code is executed, it produces following result − <br />
<div className='containers'>
['physics', 'chemistry', 1997, 2000] <br />
After deleting value at index 2 : <br />
['physics', 'chemistry', 2000] <br />
</div>
<b>Note</b>  − remove() method is discussed in subsequent section. <br />
<h3>Basic List Operations</h3>
Lists respond to the + and * operators much like strings; they mean concatenation and repetition here too, except that the result is a new list, not a string.
<br /> <br />
In fact, lists respond to all of the general sequence operations we used on strings in the prior chapter. <br />
<table class="table table-bordered" style={{textAlign:'center'}}>
'<tbody><tr>
<th style={{textAlign:'center',width:'33%'}}>Python Expression</th>
<th style={{textAlign:'center',width:'33%'}}>Results</th>
<th style={{textAlign:'center',width:'33%'}}>Description</th>
</tr>
<tr>
<td>len([1, 2, 3])</td>
<td>3</td>
<td>Length</td>
</tr>
<tr>
<td>[1, 2, 3] + [4, 5, 6]</td>
<td>[1, 2, 3, 4, 5, 6]</td>
<td>Concatenation</td>
</tr>
<tr>
<td>['Hi!'] * 4</td>
<td>['Hi!', 'Hi!', 'Hi!', 'Hi!']</td>
<td>Repetition</td>
</tr>
<tr>
<td>3 in [1, 2, 3]</td>
<td>True</td>
<td>Membership</td>
</tr>
<tr>
<td>for x in [1, 2, 3]: print x,</td>
<td>1 2 3</td>
<td>Iteration</td>
</tr>
</tbody></table>
<h3>Indexing, Slicing, and Matrixes</h3>
Because lists are sequences, indexing and slicing work the same way for lists as they do for strings.
<br /> <br />
Assuming following input − <br />
<div className='containers'>
L = ['spam', 'Spam', 'SPAM!'] <br />
</div>
<table class="table table-bordered" style={{textAlign:'center'}}>
<tbody><tr>
<th style={{textAlign:'center',width:'33%'}}>Python Expression</th>
<th style={{textAlign:'center',width:'33%'}}>Results</th>
<th style={{textAlign:'center',width:'33%'}}>Description</th>
</tr>
<tr>
<td>L[2]</td>
<td>SPAM!</td>
<td>Offsets start at zero</td>
</tr>
<tr>
<td class="ts">L[-2]</td>
<td class="ts">Spam</td>
<td>Negative: count from the right</td>
</tr>
<tr>
<td>L[1:]</td>
<td>['Spam', 'SPAM!']</td>
<td>Slicing fetches sections</td>
</tr>
</tbody></table>
<h3>Built-in List Functions & Methods</h3>
Python includes the following list functions − <br />
<table class="table table-bordered">
<tbody><tr>
<th style={{textAlign:'center',width:'5%'}}>Sr.No.</th>
<th style={{textAlign:'center',width:'95%'}}>Function with Description</th>
</tr>
<tr>
<td class="ts">1</td>
<td>cmp(list1, list2)
<p>Compares elements of both lists.</p></td>
</tr>
<tr>
<td class="ts">2</td>
<td>len(list)
<p>Gives the total length of the list.</p></td>
</tr>
<tr>
<td class="ts">3</td>
<td>max(list)
<p>Returns item from the list with max value.</p></td>
</tr>
<tr>
<td class="ts">4</td>
<td>min(list)
<p>Returns item from the list with min value.</p></td>
</tr>
<tr>
<td class="ts">5</td>
<td>list(seq)
<p>Converts a tuple into list.</p></td>
</tr>
</tbody></table>
Python includes following list methods <br />
<table class="table table-bordered">
<tbody><tr>
<th style={{textAlign:'center',width:'5%'}}>Sr.No.</th>
<th style={{textAlign:'center',width:'95%'}}>Methods with Description</th>
</tr>
<tr>
<td class="ts">1</td>
<td>list.append(obj)
<p>Appends object obj to list</p></td>
</tr>
<tr>
<td class="ts">2</td>
<td>list.count(obj)
<p>Returns count of how many times obj occurs in list</p></td>
</tr>
<tr>
<td class="ts">3</td>
<td>list.extend(seq)
<p>Appends the contents of seq to list</p></td>
</tr>
<tr>
<td class="ts">4</td>
<td>list.index(obj)
<p>Returns the lowest index in list that obj appears</p></td>
</tr>
<tr>
<td class="ts">5</td>
<td>list.insert(index, obj)
<p>Inserts object obj into list at offset index</p></td>
</tr>
<tr>
<td class="ts">6</td>
<td>list.pop(obj=list[-1])
<p>Removes and returns last object or obj from list</p></td>
</tr>
<tr>
<td class="ts">7</td>
<td>list.remove(obj)
<p>Removes object obj from list</p></td>
</tr>
<tr>
<td class="ts">8</td>
<td>list.reverse()
<p>Reverses objects of list in place</p></td>
</tr>
<tr>
<td class="ts">9</td>
<td>list.sort([func])
<p>Sorts objects of list, use compare func if given</p></td>
</tr>
</tbody></table>
        </div>
    )
}

export default List
